/* eslint-disable no-dupe-keys */
export default {
  evcs_connector: {
    name: '第三方设备接口',
    // 属性（一般与对象内容匹配）
    prop: {
      connector_id: '设备接口编号',
      connector_name: '设备接口名',
      connector_type: '设备接口类型',
      voltage_upper_limits: '额定电压上限',
      current: '额定电流',
      power: '额定功率',
      park_no: '车位号',
      national_standard: '国家标准',
      status: '状态',
      park_status: '车位状态',
      lock_status: '地锁状态',
      evcs_equipment: '设备',
      evcs_station: '充电站',
      evcs_operator: '平台商',
      created_at: '创建时间',
      updated_at: '更新时间',
      status_updated_at: '状态更新时间',
      power: '功率',
      current: '电流',
      voltage: '电压',
      qr_code: '二维码',
      sync_status: '共享同步'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      connector_id: '设备接口编号',
      connector_name: '设备接口名',
      connector_type: '设备接口类型',
      voltage_upper_limits: '额定电压上限',
      voltage_lower_limits: '额定电压下限',
      current: '额定电流',
      power: '额定功率',
      park_no: '车位号',
      national_standard: '国家标准',
      status: '状态',
      park_status: '车位状态',
      lock_status: '地锁状态',
      evcs_equipment: '设备',
      evcs_station: '充电站',
      evcs_operator: '平台商',
      created_at: '创建时间',
      updated_at: '更新时间',
      status_updated_at: '状态更新时间',
      qr_code: '二维码',
      sync_status: '共享同步',
      ev_charging_gun_status: '共享站枪状态',
      equipment_id: '设备编号',
      station_id: '充电站ID',
      station_name: '充电站名'
    },
    // Enum的属性
    connector_types: {
      household_socket: '家用插座',
      ac_connector_socket: '交流接口插座',
      ac_connector_plug: '交流接口插头',
      dc_connector_gun_head: '直流接口枪头',
      wireless_charging_stand: '无限充电座',
      other: '其他'
    },
    list_tabs: {
      all: '全部',
      offline: '离网',
      available: '空闲',
      ready: '未充电',
      charging: '充电中',
      reserved: '预约锁定',
      fault: '故障',
      unknown: '未知'
    },
    statuses: {
      offline: '离网',
      available: '空闲',
      ready: '占用(未充电)',
      charging: '占用(充电中)',
      reserved: '占用(预约锁定)',
      fault: '故障',
      unknown: '未知'
    },
    park_statuses: {
      unavailable: '未知',
      available: '空闲',
      occupy: '占用'
    },
    lock_statuses: {
      unavailable: '未知',
      unlocked: '已解锁',
      locked: '已上锁'
    },
    qr_codes: {
      true: '存在',
      false: '不存在'
    },
    sync_statuses: {
      true: '完成',
      false: '缺失'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_evcs_operator: '互联互通商家'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      orders: '订单',
      connector_traces: '调用日志'
    },
    btn: {
      equip_auth: '设备认证',
      equip_business_policy: '业务策略信息',
      start_charge: '启动充电',
      sync_ev_charging_gun: '同步共享枪口',
      sync_status: '同步实时状态'
    },
    tips: {
      evcs_api_error: '请检查: 1. ECMP->TPAS是否正常; 2. 第三方服务是否正常',
      success_sync: '同步成功',
      start_charge:
        'User -> ECMP(query_start_charge) -> EVCS(代理第三方的EVCS API调用: api_request_proxy) -> 3rd EVCS(query_start_charge) -> EVCS(回调通知3rd启动结果: notification_start_charge_result) -> EVCS(启动成功，则创建互联互通订单: create evcs_order)'
    },
    equip_auth_errors: {
      success: '认证正常，可以启动充电',
      not_ready: '设备未准备 或者 没有插枪',
      not_found: '找不到该设备 或者 对方没有允许访问该桩'
    },
    equip_business_policy_errors: {
      success: '业务策略信息返回成功'
    },
    start_charge_errors: {
      completed: '启动充电请求完成'
    },
    titles: {
      base_info: '基本信息',
      start_charge: '启动充电信息',
      equip_business_policy: '业务策略信息'
    },
    // 充电启动的响应结果
    start_charge_resps: {
      Tip: '如果启动失败，请参考 evcs 服务的 API log',
      StartChargeSeqStat: {
        '1': '启动中',
        '2': '充电中',
        '3': '停止中',
        '4': '已结束',
        '5': '未知'
      },
      FailReason: {
        '0': '成功',
        '1': '设备不存在',
        '2': '设备离线',
        '3-99': '自定义'
      }
    }
  }
}
